import { ActionTree } from 'vuex';
import { LinkToPayState, LinkToPay, AliPayCheckout } from './types';
import { RootState } from '../../types';
import * as types from './mutations-types';
import * as TinabaAPI from '@/common/TinabaAPI';
import { AxiosResponse } from 'axios';
import { processAlipayCheckout, handleAPIError, loadPaypalSDK } from '@/common/utils'
import i18n from '@/i18n'

export const actions: ActionTree<LinkToPayState, RootState> = {
    async toggleLoading ({ commit, dispatch }, isLoading = false) {
      await commit(types.toggleLoading, { isLoading });
    },
    async fetchData({ commit, state, dispatch }, id: number): Promise<LinkToPayState> {
      try {
        await commit(types.toggleLoading, { isLoading: true });
        const response: AxiosResponse<LinkToPay> = await TinabaAPI.fetchLinkToPay(id);
        if(response.data) {
          await commit(types.setPaymentDetails, { payment: response.data });

          if (response.data.status === 'PAYMENT') {
            dispatch('fetchPaypalDetails')
          }
        }
      } catch (err) {
        if (err.response.status === 410) {
          await commit(types.setPaymentDetails, { payment: err.response.data });
        } else {
          console.error('err fetchdata', err);
          handleAPIError()
        }
      } finally {
        await commit(types.toggleLoading, { isLoading: false });
      }
      return state;
    },

    async fetchPaypalDetails ({ commit, state }) {
      try {
        if (state.payment && (state.payment.paypalVas || state.payment.paypalCardVas)) {
          const { data } = await TinabaAPI.fetchPaypalData(state.payment.businessId)
          await loadPaypalSDK(data)
          await commit(types.setPaypalDetails, data)
        }
      } catch (error) {
        console.log('err fetchPaypalDetails', error);
      }
    },

    async triggerPoll ({ commit, state }) {
      try {
        if (state.payment) {
          const response: AxiosResponse<LinkToPay> = await TinabaAPI.fetchLinkToPay(state.payment.id);
          if(response.data) {
            await commit(types.setPaymentDetails, { payment: response.data });
          }
        } 
      } catch (err) {
        if (err.response.status === 410) {
          await commit(types.setPaymentDetails, { payment: err.response.data })
        } else {
          handleAPIError()
          console.error('err fetchdata', err);
          throw new Error(err) // Kill polling
        }
      }
    },

    async startAliPayCheckout ({ commit, state }) {
      try {
        if (state.payment) {
          await commit(types.toggleLoading, { isLoading: true });
          const { data }: AxiosResponse<AliPayCheckout> = await TinabaAPI.createAlipayCheckout(state.payment.id)
          await processAlipayCheckout(data)
        }
      } catch (error) {
        await commit(types.toggleLoading, { isLoading: false });
        handleAPIError()
        console.error('err alipay checkout', error);
        alert(error);
      }
      // We do not restore loader as there needs to be a redirect
    },
    async fetchErrorMessages ({ commit }) {
      try {
        await commit(types.toggleLoading, { isLoading: true });
        const { data } = await TinabaAPI.fetchErrorMessages(i18n.locale)
        await commit(types.setErrorMessages, { errors: data.errors })
      } catch (error) {
        console.log(error)
      } finally {
        await commit(types.toggleLoading, { isLoading: false });
      }
    }
  };